import styled from "styled-components";
import Button from "@material-ui/core/Button";

export default styled(Button)`
  font-family: "Chivo", sans-serif;
`;
